import { TooltipAlignType } from '@kubit/web-ui-components/tooltip/types';
import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { FONT_WEIGHT, TEXT_ALIGN } from '../../../foundations/typography';
import { Z_INDEX } from '../../../foundations/zIndex';
import { PopoverVariantType } from '../../popover/variants';
import { TextVariantType } from '../../text/variants';
import { TooltipVariantType } from '../variants';
const tooltipInternalContainerTabletMobileCommonStyles = (FOUNDATIONS, FONT) => ({
    background_color: FOUNDATIONS.color_comp_containers_bg,
    border_width: '0',
    border_radius: `${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} ${FOUNDATIONS.radius_comp_containers_modal_topradius_radiussize} 0 0`,
    padding: `${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_400} ${FOUNDATIONS.spacing_250}`,
    width: '100%',
    max_width: 'none',
    max_height: '100vh',
});
const tooltipCommonStyles = (FOUNDATIONS, FONT, SHADOWS) => ({
    headerContainer: {
        flex_direction: 'row-reverse',
        padding_bottom: FOUNDATIONS.spacing_150,
        gap: FOUNDATIONS.spacing_150,
        [DeviceBreakpointsType.TABLET]: {
            flex_direction: 'column',
            gap: FOUNDATIONS.spacing_00,
        },
        [DeviceBreakpointsType.MOBILE]: {
            flex_direction: 'column',
            gap: FOUNDATIONS.spacing_00,
        },
    },
    title: {
        font_weight: FONT_WEIGHT.font_bold,
        text_align: TEXT_ALIGN.left,
        font_variant: TextVariantType.FONT_PARAGRAPH_250,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    paragraph: {
        font_variant: TextVariantType.FONT_PARAGRAPH_200,
        font_weight: FONT_WEIGHT.font_regular,
        text_align: TEXT_ALIGN.left,
        color: FOUNDATIONS.color_neutral_font_50,
    },
    tooltipInternalContainer: {
        max_width: '20rem',
        max_height: '30rem',
        display: 'flex',
        flex_direction: 'column',
        text_align: 'left',
        width: 'max-content',
        background_color: FOUNDATIONS.color_comp_containers_tooltip_desktop_bg,
        padding: `${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_150} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_150}`,
        border_radius: FOUNDATIONS.radius_comp_container_tooltip_desktop_radiussize,
        box_shadow: SHADOWS.shadow_40,
        white_space: 'normal',
        border_width: FOUNDATIONS.border_50,
        border_style: 'solid',
        border_color: FOUNDATIONS.color_comp_containers_tooltip_desktop_border,
        [DeviceBreakpointsType.TABLET]: {
            ...tooltipInternalContainerTabletMobileCommonStyles(FOUNDATIONS, FONT),
        },
        [DeviceBreakpointsType.MOBILE]: {
            ...tooltipInternalContainerTabletMobileCommonStyles(FOUNDATIONS, FONT),
        },
    },
    dragIconContainer: {
        display: 'flex',
        justify_content: 'center',
    },
    tooltipExternalContainer: {
        [DeviceBreakpointsType.DESKTOP]: {
            padding: FOUNDATIONS.spacing_100,
            z_index: Z_INDEX.POPUP,
            display: 'none',
            position: 'fixed',
            box_sizing: 'border-box',
        },
    },
    arrowContainer: {
        background_color: FOUNDATIONS.color_comp_containers_tooltip_desktop_bg,
        arrow_size: '10px',
        arrow_position: '10px',
        [DeviceBreakpointsType.TABLET]: {
            display: 'none',
        },
        [DeviceBreakpointsType.MOBILE]: {
            display: 'none',
        },
        tooltipAlignStyles: {
            [TooltipAlignType.TOP]: {
                border_right: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_50}`,
                border_bottom: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_50}`,
            },
            [TooltipAlignType.BOTTOM]: {
                border_left: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_50}`,
                border_top: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_50}`,
            },
            [TooltipAlignType.RIGHT]: {
                border_bottom: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_50}`,
                border_left: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_50}`,
            },
            [TooltipAlignType.LEFT]: {
                border_top: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_50}`,
                border_right: `${FOUNDATIONS.border_50} solid ${FOUNDATIONS.color_neutral_border_50}`,
            },
        },
    },
    tooltipAsModal: true,
    closeButtonContainer: {
        altVariant: true,
        align_self: 'flex-end',
        [DeviceBreakpointsType.DESKTOP]: {
            align_self: 'flex-start',
        },
    },
    closeButtonIcon: {
        color: FOUNDATIONS.color_comp_actions_closebutton_primary_default_icon,
        height: FOUNDATIONS.size_300,
        width: FOUNDATIONS.size_300,
        [DeviceBreakpointsType.TABLET]: {
            height: FOUNDATIONS.size_350,
            width: FOUNDATIONS.size_350,
        },
        [DeviceBreakpointsType.MOBILE]: {
            height: FOUNDATIONS.size_350,
            width: FOUNDATIONS.size_350,
        },
    },
    popoverVariant: {
        [DeviceBreakpointsType.TABLET]: PopoverVariantType.TOOLTIP,
        [DeviceBreakpointsType.MOBILE]: PopoverVariantType.TOOLTIP,
    },
    showOverlay: {
        [DeviceBreakpointsType.DESKTOP]: false,
        [DeviceBreakpointsType.TABLET]: true,
        [DeviceBreakpointsType.MOBILE]: true,
    },
});
export const getRegularStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [TooltipVariantType.REGULAR]: {
            ...tooltipCommonStyles(FOUNDATIONS, FONT, SHADOWS),
        },
    };
};
//# sourceMappingURL=regular.js.map